import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { closeModal } from "../../store/actions/modalAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import moment from "moment";

import PurchaseRequestCreateUi from "./PurchaseRequestCreateUi";
import { CreatePurchaseRequestApi } from "../../apis/purchaseRequest.api";
import StockConfirmationDialog from "../../components/StockConfirmationDilog";

const PurchaseRequestCreateController = ({ id, callBack = () => {} }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [QrId, SetQrId] = useState();
  const QrLoading = useRef(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    shortages: [],
    originalPayload: null,
  });

  const [fields, setFields] = useState({
    err: "",
    date: moment().toISOString(),
    categoryId: null,
    categoryName: null,
    projectId: null,
    projectName: null,
    materialType: null,
    materialId: "",
    name: "",
    link: "",
    quantity: "",
    reason: "",
    additionalItems: [],
  });

  const validationSchemaForCreate = useMemo(
    () => [
      {
        required: true,
        value: fields.date,
        field: "Date",
      },
      {
        required: true,
        value: fields.categoryId,
        field: "Category",
      },
      {
        required: true,
        value: fields.materialType,
        field: "Material Type",
      },
      {
        required: true,
        value: fields.materialId,
        field: "Material Name",
      },

      {
        required: !fields.materialId || fields.materialId === "other",
        value: fields.name,
        field: "Name",
      },
      {
        required: true,
        value: fields.quantity,
        field: "Quantity",
      },
      {
        required: true,
        value: fields.reason,
        field: "Reason",
      },
    ],
    [fields],
  );

  const validateAdditionalItems = () => {
    for (let i = 0; i < fields.additionalItems.length; i++) {
      const item = fields.additionalItems[i];
      if (!item.materialType) {
        return `Material Type is required for item ${i + 2}`;
      }
      if (!item.materialId) {
        return `Material Name is required for item ${i + 2}`;
      }
      if (!item.quantity) {
        return `Quantity is required for item ${i + 2}`;
      }
    }
    return true;
  };

  const buildPayload = (purchase = false, updatedQuantities = null) => {
    let items = [];

    if (updatedQuantities) {
      const defaultItem = {
        materialId: fields.materialId,
        quantity:
          updatedQuantities[fields.materialId] !== undefined
            ? updatedQuantities[fields.materialId]
            : Number(fields.quantity),
        materialType: fields.materialType,
        reason: fields.reason || "",
        link: fields.link,

        ...(fields.materialId === "other" && {
          otherMaterialName: fields.name,
          name: fields.name,
        }),
      };
      items.push(defaultItem);

      fields.additionalItems.forEach((item) => {
        items.push({
          materialId: item.materialId,
          quantity:
            updatedQuantities[item.materialId] !== undefined
              ? updatedQuantities[item.materialId]
              : Number(item.quantity),
          materialType: item.materialType,
          reason: item.reason || "",
          link: item.link,
          ...(item.materialId === "other" && {
            otherMaterialName: item.name,
            name: item.name,
          }),
        });
      });
    } else if (purchase) {
      items = [];
      confirmationDialog.shortages.forEach((shortage) => {
        items.push({
          materialId: shortage.materialId,
          quantity: shortage.requested,
          materialType:
            fields.additionalItems.find(
              (item) => item.materialId === shortage.materialId,
            )?.materialType || fields.materialType,
          reason: fields.reason || "",
          link: fields.link,
          ...(shortage.materialId === "other" && {
            name: fields.name,
          }),
        });
      });
    } else {
      items = [
        {
          materialId: fields.materialId,
          quantity: Number(fields.quantity),
          materialType: fields.materialType,
          reason: fields.reason || "",
          link: fields.link,
          ...(fields.materialId === "other" && {
            otherMaterialName: fields.name,
            name: fields.name,
          }),
        },
      ];

      fields.additionalItems.forEach((item) => {
        items.push({
          materialId: item.materialId,
          quantity: Number(item.quantity),
          materialType: item.materialType,
          reason: item.reason || "",
          link: item.link,
          ...(item.materialId === "other" && {
            otherMaterialName: item.name,
            name: item.name,
          }),
        });
      });
    }

    const payload = {
      items,
      categoryId: fields.categoryId,
      date: fields.date,
    };

    if (fields.categoryName === "R & D" && fields.projectName) {
      payload.project = fields.projectName;
    }

    if (purchase) {
      payload.purchase = true;
    }

    return payload;
  };

  const createFunction = async (purchase = false, updatedQuantities = null) => {
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse !== true) {
      setFields({ ...fields, err: validationResponse });
      return;
    }

    if (fields.additionalItems.length > 0) {
      const additionalValidation = validateAdditionalItems();
      if (additionalValidation !== true) {
        setFields({ ...fields, err: additionalValidation });
        return;
      }
    }

    const payload = buildPayload(purchase, updatedQuantities);

    console.log("Payload to send:", payload);

    setLoading(true);

    try {
      const response = await CreatePurchaseRequestApi(payload);

      console.log("Full API Response:", response);

      const requiresConfirmation =
        response?.data?.requiresConfirmation ||
        response?.requiresConfirmation ||
        response?.data?.data?.requiresConfirmation;

      const shortages =
        response?.data?.shortages ||
        response?.shortages ||
        response?.data?.data?.shortages;


      if (requiresConfirmation && shortages?.length > 0) {
        setLoading(false);
        setConfirmationDialog({
          open: true,
          shortages: shortages,
          originalPayload: payload,
        });
        return;
      }

      callBack();
      setLoading(false);
      dispatch(
        callSnackBar(
          "Material Request created Successfully",
          SNACK_BAR_VARIETNS.suceess,
        ),
      );
      dispatch(closeModal("purchase"));
    } catch (err) {
      setLoading(false);
      setFields({ ...fields, err: err?.message || err });
      dispatch(callSnackBar(err?.message || err, SNACK_BAR_VARIETNS.error));
    }
  };

  const handleProceedWithAvailable = () => {
    const { shortages } = confirmationDialog;

    const updatedQuantities = {};
    shortages.forEach((shortage) => {
      updatedQuantities[shortage.materialId] = shortage.available;
    });

    let updatedFields = { ...fields };

    if (updatedQuantities[fields.materialId] !== undefined) {
      updatedFields.quantity = updatedQuantities[fields.materialId].toString();
    }

    if (fields.additionalItems.length > 0) {
      updatedFields.additionalItems = fields.additionalItems.map((item) => {
        if (updatedQuantities[item.materialId] !== undefined) {
          return {
            ...item,
            quantity: updatedQuantities[item.materialId].toString(),
          };
        }
        return item;
      });
    }

    setFields(updatedFields);
    setConfirmationDialog({
      open: false,
      shortages: [],
      originalPayload: null,
    });
    createFunction(false, updatedQuantities);
  };

  const handlePurchaseRemaining = () => {
    setConfirmationDialog({
      open: false,
      shortages: [],
      originalPayload: null,
    });
    createFunction(true);
  };

  const handleCloseConfirmation = () => {
    setConfirmationDialog({
      open: false,
      shortages: [],
      originalPayload: null,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    createFunction();
  };

  return (
    <>
      <PurchaseRequestCreateUi
        onSubmit={onSubmit}
        loading={loading}
        fields={fields}
        setFields={setFields}
        setLoading={setLoading}
      />

      <StockConfirmationDialog
        open={confirmationDialog.open}
        onClose={handleCloseConfirmation}
        shortages={confirmationDialog.shortages}
        onProceedWithAvailable={handleProceedWithAvailable}
        onPurchaseRemaining={handlePurchaseRemaining}
        loading={loading}
      />
    </>
  );
};

export default PurchaseRequestCreateController;
